import _ from "lodash";
import { FlowType } from "../../proofreading.model";
import { ProjectService } from "src/app/services/project.service";
import { Request, IRelectureSubRequest, IModificationSubRequest, ISourceProjectSubRequest } from "../request.model";
import { MasterProjectService } from "src/app/services/project-master.service";
import { RequestType } from "src/app/LIVECO.define";


export class CorrectionRequest extends Request {
    override type: RequestType = RequestType.TEXT_CORRECTION;
    override flow = FlowType.EZD_EXE;

    override relecture: IRelectureSubRequest = {
        members: [],
    };
    override source_project: ISourceProjectSubRequest = {
        identifier: '',
    };

    printer: IModificationSubRequest = {
        info_validity: true,
        comment: '',
    };
    seq_colors: IModificationSubRequest = {
        info_validity: true,
        comment: '',
    };

    override options: any = {
        ...this.options,
        rvf: {
            jobType: "execution",
            dateIncrement: 1
        },
    };

    constructor(data: Partial<CorrectionRequest>) {
        super(data);
        this.init(data);
    }

    onProjectCreation(service: ProjectService, master_service: MasterProjectService, lifecycle: "init" | "submit"): Promise<void> | void {
        switch (lifecycle) {
            case "init":
                this.selectServiceInProject(service);
                this.insertRequestMemberInProjectMember(service);
                this.insertCommPrinterInProject(service);
                this.insertCommSeqColorInProject(service);
                this.insertCommCustomerInProject(service);
                break;
            case "submit":
                break;
        }
        super.onProjectCreation(service, master_service, lifecycle);
    }

    // private insertCommCustomerInProject(service: ProjectService) {
    //     // Set request comm customer, name and reset service
    //     _.set(service.current || {}, 'custom.exe.commentaire_cpp', this.finalization?.comment);
    // }
    private selectServiceInProject(service: ProjectService) {
        // _.set(service.current || {}, 'custom.general.service_exe', true);
        // _.set(service.current || {}, 'custom.general.service_hd', false);
        // _.set(service.current || {}, 'custom.general.service_repro', false);
        // _.set(service.current || {}, 'custom.general.service_other', false);

        // // Remove objects from other services
        // _.set(service.current || {}, 'custom.hd', undefined);
        // _.set(service.current || {}, 'custom.repro', undefined);
        // _.set(service.current || {}, 'custom.other', undefined);

        _.set(service.current || {}, 'custom.general.flows', [FlowType.EXE, FlowType.EZD_EXE]);
        
    }

    private insertRequestMemberInProjectMember(service: ProjectService) {
        // Set request member in project member
        _.set(service.current || {}, 'custom.members', this.relecture?.members);
        // flag the easydiadem service so member edit is disabled
        service.s_requests.setFlag("project-members-creation-locked", true);
    }

    private insertCommCustomerInProject(service: ProjectService) {
        _.set(service.current || {}, 'custom.exe.comm_customer', this.finalization?.comment);
    }

    private insertCommPrinterInProject(service: ProjectService) {
        // Set request comm customer, name and reset service
        if (!this.printer?.info_validity)
            _.set(service.current || {}, 'custom.printing.comm_printer', this.printer?.comment);
    }

    private insertCommSeqColorInProject(service: ProjectService) {
        // Set request comm customer, name and reset service
        if (!this.printer?.info_validity)
            _.set(service.current || {}, 'custom.colors.comm_seq_colors', this.seq_colors?.comment);
    }
}
